module.exports = __webpack_public_path__ + "static/media/ICON-SOBRE1.49cbd4e1.svg";